"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8633],{

/***/ 52882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ HeaderHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var HeaderHome = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "16.983",
        height: props.height || "16.984",
        viewBox: "0 0 16.983 16.984",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "home",
            fill: props.color || "#000",
            d: "M17.026,7.387h0L10.1.458a1.563,1.563,0,0,0-2.211,0L.961,7.383.954,7.39a1.563,1.563,0,0,0,1.04,2.664l.048,0h.276v5.1a1.832,1.832,0,0,0,1.83,1.83H6.859a.5.5,0,0,0,.5-.5v-4a.836.836,0,0,1,.835-.835h1.6a.836.836,0,0,1,.835.835v4a.5.5,0,0,0,.5.5h2.711a1.832,1.832,0,0,0,1.83-1.83v-5.1h.256a1.564,1.564,0,0,0,1.107-2.669Zm-.7,1.507a.565.565,0,0,1-.4.167h-.754a.5.5,0,0,0-.5.5v5.6a.836.836,0,0,1-.835.835H11.62v-3.5a1.832,1.832,0,0,0-1.83-1.83h-1.6a1.832,1.832,0,0,0-1.83,1.83v3.5H4.148a.836.836,0,0,1-.835-.835v-5.6a.5.5,0,0,0-.5-.5H2.052a.568.568,0,0,1-.391-.97h0L8.589,1.162a.568.568,0,0,1,.8,0l6.926,6.926,0,0A.57.57,0,0,1,16.321,8.894Zm0,0",
            transform: "translate(-0.499)"
        })
    });
};


/***/ }),

/***/ 25823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ CommonHeaderIconsMobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
;// CONCATENATED MODULE: ./src/assets/svgExports/FilledUserIcon.js

var FilledUserIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "15.228",
        height: props.height || "15.603",
        viewBox: "0 0 22.378 25",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "user",
            transform: "translate(-24.165)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Group_132777",
                    "data-name": "Group 132777",
                    transform: "translate(28.865)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Group_132776",
                        "data-name": "Group 132776",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Path_229346",
                            "data-name": "Path 229346",
                            d: "M117.282,0a6.491,6.491,0,1,0,6.491,6.491A6.508,6.508,0,0,0,117.282,0Z",
                            transform: "translate(-110.791)",
                            fill: props.color
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Group_132779",
                    "data-name": "Group 132779",
                    transform: "translate(24.165 13.446)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Group_132778",
                        "data-name": "Group 132778",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Path_229347",
                            "data-name": "Path 229347",
                            d: "M46.495,252.563a6.05,6.05,0,0,0-.652-1.19,8.068,8.068,0,0,0-5.584-3.515,1.2,1.2,0,0,0-.822.2,6.919,6.919,0,0,1-8.163,0,1.063,1.063,0,0,0-.822-.2,8.009,8.009,0,0,0-5.584,3.515,6.974,6.974,0,0,0-.652,1.19.6.6,0,0,0,.028.539,11.313,11.313,0,0,0,.765,1.134,10.773,10.773,0,0,0,1.3,1.474,16.987,16.987,0,0,0,1.3,1.134,12.926,12.926,0,0,0,15.419,0,12.46,12.46,0,0,0,1.3-1.134,13.093,13.093,0,0,0,1.3-1.474,9.948,9.948,0,0,0,.765-1.134A.484.484,0,0,0,46.495,252.563Z",
                            transform: "translate(-24.165 -247.841)",
                            fill: props.color
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/assets/svgExports/WhatsAppIcon2.js

var WhatsappIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        id: "whatsapp",
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "15.228",
        height: props.height || "15.603",
        viewBox: "0 0 25 25",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_50043",
                "data-name": "Path 50043",
                d: "M21.375,3.593A12.648,12.648,0,0,0,12.547,0,12.409,12.409,0,0,0,1.767,18.581L0,25l6.6-1.721a13.086,13.086,0,0,0,5.954,1.507A12.406,12.406,0,0,0,21.359,3.633Z",
                transform: "translate(0)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_50044",
                "data-name": "Path 50044",
                d: "M12.481,22.575h-.023a10.5,10.5,0,0,1-5.641-1.66L2.911,21.93l1.047-3.8-.249-.391A10.28,10.28,0,0,1,2.13,12.263C2.13,3.1,13.323-1.477,19.8,5A10.305,10.305,0,0,1,12.481,22.575Z",
                transform: "translate(0.089 0.082)",
                fill: "#4caf50"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_50045",
                "data-name": "Path 50045",
                d: "M17.987,14.638l-.009.078c-.314-.156-1.841-.9-2.125-1.006-.639-.236-.458-.037-1.684,1.367-.182.2-.364.219-.673.078a8.454,8.454,0,0,1-2.5-1.547,9.451,9.451,0,0,1-1.729-2.156c-.305-.527.333-.6.915-1.7a.573.573,0,0,0-.026-.546c-.078-.156-.7-1.688-.96-2.3s-.507-.531-.7-.531a1.55,1.55,0,0,0-1.425.358c-1.681,1.848-1.257,3.754.181,5.781,2.827,3.7,4.333,4.381,7.087,5.327a4.31,4.31,0,0,0,1.958.126,3.206,3.206,0,0,0,2.1-1.485A2.578,2.578,0,0,0,18.581,15c-.077-.141-.281-.219-.594-.359Z",
                transform: "translate(0.249 0.265)",
                fill: "#fff"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/svgExports/FilledShoppingCart.js

var FilledShoppingCart = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "15.228",
        height: props.height || "15.603",
        viewBox: "0 0 25.109 22",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "shopping-cart",
            transform: "translate(0 -31.001)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    id: "Ellipse_5152",
                    "data-name": "Ellipse 5152",
                    cx: "2",
                    cy: "2",
                    r: "2",
                    transform: "translate(8.769 49.001)",
                    fill: props.color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    id: "Ellipse_5153",
                    "data-name": "Ellipse 5153",
                    cx: "2",
                    cy: "2",
                    r: "2",
                    transform: "translate(16.769 49.001)",
                    fill: props.color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_229354",
                    "data-name": "Path 229354",
                    d: "M.736,32.5H3.8L7.355,45.174l-.279.568A2.248,2.248,0,0,0,9.05,49H21.431a.75.75,0,0,0,0-1.5H9.05a.749.749,0,0,1-.658-1.085L8.6,46H21.431a.738.738,0,0,0,.708-.544l2.942-10.5a.764.764,0,0,0-.12-.658.733.733,0,0,0-.588-.3H5.754l-.688-2.455A.738.738,0,0,0,4.358,31H.736a.75.75,0,0,0,0,1.5Z",
                    transform: "translate(0 0)",
                    fill: props.color
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/assets/svgExports/SearchIcon.js
var SearchIcon = __webpack_require__(50127);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var storeInfo = __webpack_require__(17321);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(67936);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/utils/handleRedirectToHomePage.js
var handleRedirectToHomePage = __webpack_require__(54051);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(99375);
// EXTERNAL MODULE: ./src/utils/getWhatsAppRedirectionUrl.js
var getWhatsAppRedirectionUrl = __webpack_require__(30066);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Header/utils.tsx
var utils = __webpack_require__(69153);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/CommonHeaderIcons/index.js

















var CommonHeaderIconsMobile = function(props) {
    var renderCartItemsQuantity = function renderCartItemsQuantity(icon) {
        return icon.name === "Cart" && (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "cart-item-length-comp absolute  ".concat((props === null || props === void 0 ? void 0 : props.color) === "#ffffff" ? "filter-invert-1" : "filter-invert-0"),
            children: items.length
        });
    };
    var oldHeaderIcons = function oldHeaderIcons() {
        return IconList.map(function(icon) {
            if (!icon.isVisible) {
                return;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "pointer pr10px mobile-icons",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: icon.imgSrc,
                            onClick: function() {
                                return iconClick(icon.href);
                            },
                            style: icon.customStyle || {}
                        }),
                        renderCartItemsQuantity(icon)
                    ]
                })
            }, icon.name);
        });
    };
    var differentHeaderIcons = function differentHeaderIcons() {
        return IconListForHeaders.map(function(icon) {
            if (!icon.isVisible) {
                return;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "flex relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "pointer pr10px mobile-icons",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ml3 pl4px",
                            onClick: function() {
                                return iconClick(icon.href);
                            },
                            style: icon.customStyle || {},
                            children: icon.svg
                        }),
                        renderCartItemsQuantity(icon)
                    ]
                })
            }, icon.name);
        });
    };
    var isHeaderDifferent = /**
   * @return {boolean} true for headers whose background color can be changeable
   */ function isHeaderDifferent() {
        return (props === null || props === void 0 ? void 0 : props.headerName) === "header11" || (props === null || props === void 0 ? void 0 : props.headerName) === "header12" || (props === null || props === void 0 ? void 0 : props.headerName) === "header14";
    };
    var ref, ref1;
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var IconList = [
        {
            name: "Search",
            imgSrc: "/assets/icons/search.svg",
            href: routes.PATH.SEARCH,
            isVisible: true,
            customStyle: {}
        },
        {
            name: "Contact Us",
            imgSrc: "/assets/icons/whatsapp.svg",
            href: false,
            isVisible: true
        },
        {
            name: "Cart",
            imgSrc: "/assets/icons/shopping-cart.svg",
            href: routes.PATH.CART,
            isVisible: !(0,utils/* isWebFrameRoute */.RA)()
        },
        {
            name: "orders",
            imgSrc: "/assets/icons/user.svg",
            href: routes.PATH.ORDERS,
            isVisible: true
        }, 
    ];
    var IconListForHeaders = [];
    if ((props === null || props === void 0 ? void 0 : props.headerName) === "header14") {
        if (props === null || props === void 0 ? void 0 : props.isWhatsappIconVisible) IconListForHeaders = [
            {
                name: "Contact Us",
                svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappIcon, {
                    color: props.color,
                    width: "25",
                    height: "25"
                }),
                href: false
            }, 
        ];
    } else {
        IconListForHeaders = [
            {
                name: "Search",
                svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* SearchIcon */.W, {
                    color: props.color,
                    width: "25",
                    height: "25"
                }),
                href: routes.PATH.SEARCH,
                isVisible: true,
                customStyle: {}
            },
            {
                name: "Contact Us",
                svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappIcon, {
                    color: props.color,
                    width: "25",
                    height: "25"
                }),
                href: false,
                isVisible: true
            },
            {
                name: "Cart",
                svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilledShoppingCart, {
                    color: props.color,
                    width: "25",
                    height: "25"
                }),
                href: routes.PATH.CART,
                isVisible: !(0,utils/* isWebFrameRoute */.RA)()
            },
            {
                name: "orders",
                svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilledUserIcon, {
                    color: props.color,
                    width: "25",
                    height: "25"
                }),
                href: routes.PATH.ORDERS,
                isVisible: true
            }, 
        ];
    }
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            items: state.cartReducer.items,
            userData: state.userReducer
        };
    }), items = ref2.items, userData = ref2.userData;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var dispatch = (0,es/* useDispatch */.I0)();
    var iconClick = function(href) {
        var isB2bStore = (0,getStoreType/* getStoreType */.K)(storeData) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
        if (href === routes.PATH.CART && isB2bStore) {
            dispatch((0,storeInfo/* toggleRfqFormModal */.H4)());
            return;
        }
        if (storePhone) {
            var ref, ref1;
            dispatch((0,logs/* pushEventsLog */.U)({
                event_name: "Cx_WA_Clicked",
                data: {
                    store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                    domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                    page: window.location.href,
                    device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                    cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
                }
            }));
        }
        if (href) {
            var ref2;
            router_default().push((0,routes.getRoute)(href, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
        } else {
            (0,getWhatsAppRedirectionUrl/* openWhatsAppLeadModal */.iM)();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center common-header-icons-mobile justify-end relative ".concat(props.className),
        children: [
            ((props === null || props === void 0 ? void 0 : props.headerName) === "header14" || (props === null || props === void 0 ? void 0 : props.headerName) === "header12" && !!(props === null || props === void 0 ? void 0 : props.isStoreLogoVisible)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "".concat((props === null || props === void 0 ? void 0 : props.headerName) === "header14" ? "absolute l-35" : "", "\n          ").concat((storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.logo_image) ? "logo_image" : "dn"),
                src: storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.logo_image,
                alt: "store logo",
                onClick: function() {
                    return (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : storeData.domain);
                }
            }),
            isHeaderDifferent() ? differentHeaderIcons() : oldHeaderIcons()
        ]
    });
};


/***/ }),

/***/ 44128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ StoreNameComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26706);
/* harmony import */ var _utils_handleRedirectToHomePage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54051);
/* harmony import */ var _utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73494);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44541);
/* harmony import */ var _utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68491);






var StoreNameComp = function(param) {
    var _customClass = param.customClass, customClass = _customClass === void 0 ? "" : _customClass, _showLogo = param.showLogo, showLogo = _showLogo === void 0 ? false : _showLogo;
    var storeData = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    var storeInfo = storeData.store_info, theme = storeData.theme;
    var storeLogo = (0,_utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(storeData);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "name-logo-container",
        children: [
            storeLogo && (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getVisibilityForHeader */ .g)(theme === null || theme === void 0 ? void 0 : theme.store_logo_status) && showLogo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: "store-logo pointer",
                src: storeLogo,
                alt: "store logo",
                onClick: function() {
                    return (0,_utils_handleRedirectToHomePage__WEBPACK_IMPORTED_MODULE_2__/* .redirectToHomePage */ .A)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.domain);
                }
            }),
            (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getVisibilityForHeader */ .g)(theme === null || theme === void 0 ? void 0 : theme.store_name_status) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "store-name flex items-center pointer ".concat(customClass ? customClass : ""),
                title: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.name,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    onClick: function() {
                        return (0,_utils_handleRedirectToHomePage__WEBPACK_IMPORTED_MODULE_2__/* .redirectToHomePage */ .A)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.domain);
                    },
                    children: [
                        " ",
                        storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.name
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 20949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15483);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var _getUrlParams__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5492);




var checkIfShowDummyProduts = function(storeData) {
    var isPreview = (0,_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var isPremium = !!storeData.premium;
    var items_available = (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6 && (0,_getUrlParams__WEBPACK_IMPORTED_MODULE_3__/* .getUrlParams */ .D)([
        _constants__WEBPACK_IMPORTED_MODULE_2__/* .PREVIEW_PARAMS.ITEMS_AVAILABLE */ .I.ITEMS_AVAILABLE
    ])).items_available;
    var isItemsAvailable = +items_available;
    return isPreview && (!isPremium || !isItemsAvailable);
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfShowDummyProduts);


/***/ }),

/***/ 68491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20949);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);


/**
 * function to get store logo in case of dummy or actual data
 * @param storeInfo
 * @returns
 */ var getActualOrDsStoreLogo = function(storeInfo) {
    var ref;
    var showDummyData = (0,_checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(storeInfo);
    return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.logo_image) || (showDummyData ? _constants__WEBPACK_IMPORTED_MODULE_1__/* .DS_LOGO_IMAGE_URL */ .pP : null);
};
/* harmony default export */ __webpack_exports__["Z"] = (getActualOrDsStoreLogo);


/***/ }),

/***/ 4956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p6": function() { return /* binding */ showMyAccount; }
/* harmony export */ });
/* unused harmony export isUserLoggedIn */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13508);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80344);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6337);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44541);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13886);






var isUserLoggedIn = function() {
    var ref;
    return !!((ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().userReducer) === null || ref === void 0 ? void 0 : ref.isLogin);
};
var showMyAccount = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6 && _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__/* .IS_MOBILE */ .q$ && _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_WEBVIEW */ .x5 && isUserLoggedIn();
};
var myAccountNavData = {
    page_name: "My Account",
    slug_url: _routes__WEBPACK_IMPORTED_MODULE_3__.PATH.MY_ACCOUNT,
    page_type: "my-account"
};
var getNavList = function(navigationItems) {
    var visibleItemsLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_VISIBLE_NAV_LINKS */ .Ow, showCategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var subNavObj = {
        page_type: "subNavList",
        subNavs: [],
        is_editable: false,
        page_id: "616d2bd6152384798123d775",
        page_name: showCategories ? "Categories" : "More",
        slug_url: showCategories ? "more" : "subNavList"
    };
    var showMyAccountSection = showMyAccount();
    if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > 0) {
        var tempNavList = [];
        if (showCategories) {
            tempNavList = navigationItems.filter(function(nav) {
                return nav.page_type !== "shop";
            });
        } else {
            tempNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(navigationItems);
        }
        if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > visibleItemsLength) {
            var extractedNavList = tempNavList.splice(visibleItemsLength, tempNavList.length);
            subNavObj.subNavs = extractedNavList;
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
            }
            var newNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(tempNavList).concat([
                subNavObj
            ]);
            return newNavList;
        } else {
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
                tempNavList.push(subNavObj);
            }
            return tempNavList;
        }
    }
    return [];
};
/* harmony default export */ __webpack_exports__["ZP"] = (getNavList);


/***/ }),

/***/ 54051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ redirectToHomePage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44541);


var redirectToHomePage = function(path, domain) {
    next_router__WEBPACK_IMPORTED_MODULE_0___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(path, domain));
};


/***/ }),

/***/ 73494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getVisibilityForFooter; },
/* harmony export */   "g": function() { return /* binding */ getVisibilityForHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
// the status defines the visibility of logo or name with respect to header and footer

var STATUS_DISABLED = 0;
var STATUS_SHOW_ON_HEADER = 1;
var STATUS_SHOW_ON_FOOTER = 2;
var STATUS_SHOW_ON_HEADER_FOOTER = 3;
// const STATUS_DONT_SHOW_ON_HEADER_FOOTER = 4;
var COMMON_STATUS_SHOW = [
    STATUS_DISABLED,
    STATUS_SHOW_ON_HEADER_FOOTER
];
function getVisibilityForHeader(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_HEADER
    ]).includes(status);
}
function getVisibilityForFooter(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_FOOTER
    ]).includes(status);
}


/***/ })

}]);